import { simd } from "wasm-feature-detect";

const DEBUG = false;

function analytics(wasm: boolean, m3d: boolean) {
	const hitData = {
		"wasm_loaded": wasm ? 1 : 0,
		"3Dmap_loaded": m3d ? 1 : 0,
	};

	Mapy.getComponent("logger").log("mapLoadHit", hitData);
	/* eslint-disable-next-line */
	DEBUG && console.log({
		action: "mapLoadHit",
		...hitData,
	});
}

async function wasmCheck() {
	try {
		const state = await simd();

		return state;
	} catch (exc) {
		//
	}

	return false;
}

// check pro 3d - vykresleni trojuhelniku
function m3dCheck() {
	try {
		const canvas = document.createElement("canvas");

		canvas.width = 1024;
		canvas.height = 768;

		const gl = canvas.getContext("webgl2") || canvas.getContext("webgl");

		if (!gl) {
			return false;
		}

		const vertices = [
			-0.5,
			0.5,
			0.0,
			-0.5,
			-0.5,
			0.0,
			0.5,
			-0.5,
			0.0,
		];

		const indices = [0, 1, 2];

		 // Create an empty buffer object to store vertex buffer
		const vertexBuffer = gl.createBuffer();

		// Bind appropriate array buffer to it
		gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);

		// Pass the vertex data to the buffer
		gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);

		// Unbind the buffer
		gl.bindBuffer(gl.ARRAY_BUFFER, null);

		// Create an empty buffer object to store Index buffer
		const indexBuffer = gl.createBuffer();

		// Bind appropriate array buffer to it
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);

		// Pass the vertex data to the buffer
		gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);

		// Unbind the buffer
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

		/*================ Shaders ====================*/

		// Vertex shader source code
		const vertCode = `
			attribute vec3 coordinates;

			void main(void) {
				gl_Position = vec4(coordinates, 1.0);
			}
		`;

		// Create a vertex shader object
		const vertShader = gl.createShader(gl.VERTEX_SHADER);

		// Attach vertex shader source code
		gl.shaderSource(vertShader, vertCode);

		// Compile the vertex shader
		gl.compileShader(vertShader);

		//fragment shader source code
		const fragCode = `
			void main(void) {
				gl_FragColor = vec4(0.0, 0.0, 0.0, 0.1);
			}
		`;

		// Create fragment shader object
		const fragShader = gl.createShader(gl.FRAGMENT_SHADER);

		// Attach fragment shader source code
		gl.shaderSource(fragShader, fragCode);

		// Compile the fragmentt shader
		gl.compileShader(fragShader);

		// Create a shader program object to store
		// the combined shader program
		const shaderProgram = gl.createProgram();

		// Attach a vertex shader
		gl.attachShader(shaderProgram, vertShader);

		// Attach a fragment shader
		gl.attachShader(shaderProgram, fragShader);

		// Link both the programs
		gl.linkProgram(shaderProgram);

		// Use the combined shader program object
		gl.useProgram(shaderProgram);

		/*======= Associating shaders to buffer objects =======*/

		// Bind vertex buffer object
		gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);

		// Bind index buffer object
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);

		// Get the attribute location
		const coord = gl.getAttribLocation(shaderProgram, "coordinates");

		// Point an attribute to the currently bound VBO
		gl.vertexAttribPointer(coord, 3, gl.FLOAT, false, 0, 0);

		// Enable the attribute
		gl.enableVertexAttribArray(coord);

		/*=========Drawing the triangle===========*/

		// Clear the canvas
		gl.clearColor(0.5, 0.5, 0.5, 0.9);

		// Enable the depth test
		gl.enable(gl.DEPTH_TEST);

		// Clear the color buffer bit
		gl.clear(gl.COLOR_BUFFER_BIT);

		// Set the view port
		gl.viewport(0, 0, canvas.width, canvas.height);

		// Draw the triangle
		gl.drawElements(gl.TRIANGLES, indices.length, gl.UNSIGNED_SHORT, 0);

		// clean
		gl.deleteBuffer(vertexBuffer);
		gl.deleteBuffer(indexBuffer);
		gl.deleteShader(vertShader);
		gl.deleteShader(fragShader);
		gl.deleteProgram(shaderProgram);

		if (DEBUG) {
			canvas.style.position = "absolute";
			canvas.style.left = "0px";
			canvas.style.top = "0px";
			canvas.style.zIndex = "1000";

			document.body.append(canvas);
		} else {
			canvas.remove();
		}

		return true;
	} catch (exc) {
		//
	}

	return false;
}

export async function wasmPrepare() {
	const m3d = m3dCheck();
	const wasm = await wasmCheck();

	analytics(wasm, m3d);
}
